import React, { useState } from 'react';
import { GoogleMap, MarkerClusterer, Marker } from '@react-google-maps/api';
import { loadMapScript } from './utils';
import GoogleMapStyles from './GoogleMapStyles.json';








const MaxFitZoom = 15;

const options = {
  imagePath:
  'https://developers.google.com/maps/documentation/javascript/examples/markerclusterer/m'
};









const GoogleMapComponent = ({
  markers,
  mapOptions,
  mapContainerStyle,
  mapAPIKey,
  coordinates
}) => {
  const [mapRef, setMapRef] = useState(null);

  const fitBounds = (map) => {
    if (map && markers && markers.length) {
      const bounds = new window.google.maps.LatLngBounds();
      markers.map((marker) => {
        bounds.extend(marker);
        return marker.id;
      });

      // handle bound for only one marker
      if (bounds.getNorthEast().equals(bounds.getSouthWest())) {
        const extendPoint1 = new window.google.maps.LatLng(
          bounds.getNorthEast().lat() + 0.01,
          bounds.getNorthEast().lng() + 0.01
        );
        const extendPoint2 = new window.google.maps.LatLng(
          bounds.getNorthEast().lat() - 0.01,
          bounds.getNorthEast().lng() - 0.01
        );
        bounds.extend(extendPoint1);
        bounds.extend(extendPoint2);
      }

      map.fitBounds(bounds);
      // set the default after fitting bounds;
      map.setZoom(Math.min(map.getZoom(), MaxFitZoom));
    }
  };

  React.useEffect(() => {
    fitBounds(mapRef);
  }, [markers.length]);

  const { isLoaded } = loadMapScript({ mapAPIKey });

  const loadHandler = (map) => {
    setMapRef(map);
    fitBounds(map);
  };

  const getClusteredMarkers = (clusterer) => {
    const markerElems = [];
    markers.forEach((location) => {
      if (location.count && location.count > 1) {
        for (let i = 0; i < location.count; i += 1) {
          markerElems.push(
            <Marker
              key={`${location.id}_m${i}`}
              position={location}
              clusterer={clusterer} />

          );
        }
      } else {
        markerElems.push(
          <Marker key={location.id} position={location} clusterer={clusterer} />
        );
      }
    });
    return markerElems;
  };

  const renderMap = () =>
  <>
      <GoogleMap
      onLoad={loadHandler}
      id="marker-example"
      mapContainerStyle={mapContainerStyle}
      zoom={3}
      center={coordinates}
      clickableIcons={false}
      options={mapOptions}>

        <MarkerClusterer options={options}>
          {(clusterer) => getClusteredMarkers(clusterer)}
        </MarkerClusterer>
      </GoogleMap>
    </>;


  return isLoaded ? renderMap() : null;
};

GoogleMapComponent.defaultProps = {
  mapOptions: {
    streetViewControl: false,
    mapTypeControl: false,
    styles: GoogleMapStyles
  },
  mapContainerStyle: {
    height: '200px',
    width: '520px'
  },
  coordinates: {
    lat: 89.5555,
    lng: -73.5555
  }
};

export default GoogleMapComponent;